/* Continuous review marquee — drag-to-scrub on any pointer, auto-scroll
   resumes from the exact released position (no snap-back, no stuck state).
   Progressive enhancement: the CSS @keyframes animation (aycan-reviews-card.css /
   aycan-testimonials.liquid inline style) already scrolls with zero JS: this
   script takes over rendering via requestAnimationFrame once it boots, so a
   JS failure just leaves the CSS-only version running. */
(function () {
  var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var canHover = window.matchMedia && window.matchMedia('(hover: hover) and (pointer: fine)').matches;

  function initMarquee(viewport) {
    var marquee = viewport.querySelector('.aycan-reviews__marquee');
    if (!marquee || marquee.dataset.aycanMarqueeInit === '1') return;
    marquee.dataset.aycanMarqueeInit = '1';

    var speedSeconds = parseFloat(getComputedStyle(marquee).getPropertyValue('--reviews-speed')) || 75;
    var halfWidth = 0;
    var offset = 0;
    var pxPerMs = 0;
    var dragging = false;
    var dragStartX = 0;
    var dragStartOffset = 0;
    var hovering = false;
    var rafId = null;
    var lastTime = null;

    function measure() {
      halfWidth = marquee.scrollWidth / 2;
      pxPerMs = halfWidth / (speedSeconds * 1000);
    }

    function wrap(value) {
      if (halfWidth <= 0) return 0;
      return ((value % halfWidth) + halfWidth) % halfWidth;
    }

    function paint() {
      marquee.style.transform = 'translateX(' + -offset + 'px)';
    }

    function tick(time) {
      if (lastTime === null) lastTime = time;
      var delta = time - lastTime;
      lastTime = time;

      if (!dragging && !hovering && !reduceMotion) {
        offset = wrap(offset + delta * pxPerMs);
        paint();
      }
      rafId = requestAnimationFrame(tick);
    }

    function start() {
      marquee.style.animation = 'none';
      measure();
      paint();
      lastTime = null;
      rafId = requestAnimationFrame(tick);
    }

    window.addEventListener('resize', measure);

    if (canHover) {
      viewport.addEventListener('mouseenter', function () { hovering = true; });
      viewport.addEventListener('mouseleave', function () { hovering = false; });
    }

    marquee.addEventListener('pointerdown', function (event) {
      dragging = true;
      dragStartX = event.clientX;
      dragStartOffset = offset;
      marquee.setPointerCapture(event.pointerId);
      marquee.style.transition = 'none';
    });

    marquee.addEventListener('pointermove', function (event) {
      if (!dragging) return;
      var delta = event.clientX - dragStartX;
      offset = wrap(dragStartOffset - delta);
      paint();
    });

    function endDrag(event) {
      if (!dragging) return;
      dragging = false;
      if (marquee.hasPointerCapture(event.pointerId)) {
        marquee.releasePointerCapture(event.pointerId);
      }
      // Auto-scroll resumes on the very next tick from the current offset —
      // no snapping, no delay, no stuck state.
    }
    marquee.addEventListener('pointerup', endDrag);
    marquee.addEventListener('pointercancel', endDrag);

    if (marquee.querySelector('img')) {
      var pending = 0;
      marquee.querySelectorAll('img').forEach(function (img) {
        if (img.complete) return;
        pending += 1;
        img.addEventListener('load', function () {
          pending -= 1;
          if (pending === 0) measure();
        }, { once: true });
      });
    }

    start();
  }

  function init(scope) {
    (scope || document).querySelectorAll('.aycan-reviews--scroll .aycan-reviews__viewport').forEach(initMarquee);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(); });
  } else {
    init();
  }
  document.addEventListener('shopify:section:load', function (event) { init(event.target); });
})();
